export const colors = {
  primary: "#2563eb",
  primaryDark: "#1e40af",

  success: "#15803d",
  warning: "#f59e0b",
  danger: "#dc2626",
  info: "#0284c7",

  slate900: "#0f172a",
  slate700: "#334155",
  slate500: "#64748b",
  slate200: "#e2e8f0",
  slate100: "#f1f5f9",
  slate50: "#f8fafc",

  white: "#ffffff",
};